import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'; // Ajoutez useLocation
import { authService } from '../../services/auth.service';
import './LoginPage.css';

const LoginPage = () => {
    const [formData, setFormData] = useState({
        email: '',
        password: '',
        rememberMe: false
    });
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation(); // Ajoutez ceci

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            await authService.login({
                email: formData.email,
                password: formData.password
            });

            if (formData.rememberMe) {
                localStorage.setItem('rememberMe', 'true');
            }

            // Modifiez la redirection ici
            if (location.state?.from === '/pricing') {
                navigate('/pricing');
            } else {
                navigate('/dashboard');
            }
        } catch (error) {
            if (error.message?.includes('Failed to fetch')) {
                setError('Erreur de connexion : Veuillez vérifier votre connexion internet');
            } else {
                setError(error.message);
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className="glass-bg">
                <div className="glass-blob blob-1"></div>
                <div className="glass-blob blob-2"></div>
            </div>

            <div className="login-container">
                <div className="login-header">
                    <h1>Connexion</h1>
                    <p>Bienvenue sur Sumfy</p>
                </div>

                {/* Ajoutez le message conditionnel pour pricing */}
                {location.state?.from === '/pricing' && (
                    <div className="info-message">
                        Connectez-vous pour accéder à nos offres d'abonnement
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            required
                            placeholder="votre@email.com"
                            value={formData.email}
                            onChange={handleChange}
                            disabled={isLoading}
                            className="w-full"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">Mot de passe</label>
                        <div className="password-input">
                            <input
                                type={showPassword ? "text" : "password"}
                                id="password"
                                name="password"
                                required
                                placeholder="••••••••"
                                value={formData.password}
                                onChange={handleChange}
                                disabled={isLoading}
                            />
                            <button
                                type="button"
                                onClick={togglePasswordVisibility}
                                className="password-toggle"
                            >
                                <i className={`fas fa-${showPassword ? 'eye-slash' : 'eye'}`}></i>
                            </button>
                        </div>
                    </div>

                    {error && <div className="error-message">{error}</div>}

                    <button
                        type="submit"
                        className="login-btn"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Connexion...' : 'Se connecter'}
                    </button>
                    <div className="register-link">
                        Pas encore de compte ? <a href="/register">S'inscrire</a>
                    </div>
                </form>
            </div>
        </>
    );
};

export default LoginPage;